import * as React from 'react';

function SparkleIconComponent(props: any) {
  return (
    <svg
      height="100%"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.16671 5.33325H8.16671C8.16671 4.50659 7.49337 3.83325 6.66671 3.83325V2.83325C7.49337 2.83325 8.16671 2.15992 8.16671 1.33325H9.16671C9.16671 2.15992 9.84004 2.83325 10.6667 2.83325V3.83325C9.84004 3.83325 9.16671 4.50659 9.16671 5.33325ZM8.67337 3.83325H8.66337L8.67337 3.83992V3.83325ZM8.66337 2.83325H8.67337L8.66337 2.82659V2.83325ZM6.66671 6.83325C5.47337 6.83325 4.50004 5.85992 4.50004 4.66658H3.50004C3.50004 5.85992 2.52671 6.83325 1.33337 6.83325V7.83325C2.52671 7.83325 3.50004 8.80659 3.50004 9.99992H4.50004C4.50004 8.80659 5.47337 7.83325 6.66671 7.83325V6.83325ZM4.00004 8.29992C3.75337 7.91325 3.42337 7.58325 3.03337 7.33325C3.42004 7.08659 3.75004 6.75659 4.00004 6.36659C4.24671 6.75325 4.57671 7.08325 4.96671 7.33325C4.58004 7.57992 4.25004 7.90992 4.00004 8.29992ZM14.6667 10.1666C12.7367 10.1666 11.1667 8.59658 11.1667 6.66658H10.1667C10.1667 8.59658 8.59671 10.1666 6.66671 10.1666V11.1666C8.59671 11.1666 10.1667 12.7366 10.1667 14.6666H11.1667C11.1667 12.7366 12.7367 11.1666 14.6667 11.1666V10.1666ZM10.6667 12.6133C10.2367 11.7766 9.55337 11.0966 8.72004 10.6666C9.55671 10.2366 10.2367 9.55325 10.6667 8.71992C11.0967 9.55659 11.78 10.2366 12.6134 10.6666C11.7767 11.0966 11.0967 11.7799 10.6667 12.6133Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SparkleIconComponent;
